<template>
  <v-dialog
    v-model="phoneEditor"
    persistent
    :fullscreen="mobile"
    :max-width="mobile ? '100%' : '50%'"
    :retain-focus="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-if="mode == 'create'"
        v-bind="attrs"
        v-on="on"
        right
        style="float:right"
        color="secondary"
        v-on:click="loadPhoneDetails()"
        ><v-icon small left>fas fa-plus</v-icon>Novo Número</v-btn
      >
      <v-btn
        v-if="mode == 'edit'"
        v-bind="attrs"
        v-on="on"
        x-small
        icon
        v-on:click="loadPhoneDetails()"
        style="margin-left:15px;margin-right:15px;"
        color="accent"
      >
        <v-icon>fas fa-pencil-alt</v-icon></v-btn
      >
    </template>
    <v-card>
      <v-list-item two-line>
        <v-list-item-avatar tile size="50">
          <v-icon color="secondary" size="30px">fas fa-link</v-icon>
        </v-list-item-avatar>
        <v-list-item-content style="user-select:none">
          <v-list-item-title class="headline mb-1" style="font-weight:500">
            <span v-if="mode == 'create'"
              >Novo <br v-if="mobile" />
              Número</span
            >
            <span v-if="mode == 'edit'"
              >Alterar <br v-if="mobile" />
              Número</span
            >
            <span
              class="closeBtn"
              v-bind:style="{ top: mobile ? '-30px' : '-5px' }"
              @click="phoneEditor = false"
              ><v-icon color="error">fas fa-times</v-icon></span
            >
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-card-text>
        <v-form lazy-validation ref="form" v-model="formValid">
          <v-container fluid class="my-0 py-0">
            <v-row class="my-0 py-0">
              <v-col cols="12" md="6" class="my-0 py-0">
                <v-text-field
                  :disabled="disableForm"
                  :counter="15"
                  v-model="phoneData.name"
                  :rules="rules.required"
                  label="Nome"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="my-0 py-0">
                <v-text-field
                  :disabled="disableForm"
                  v-model="phoneData.number"
                  label="Número"
                  type="tel"
                  :rules="rules.phone"
                  v-mask="['+55 (##) ####-####', '+55 (##) #####-####']"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12">
                <p style="margin-bottom:4px">Jornada de trabalho:</p>
                <v-simple-table dense :key="forceReload">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-center">Dia</th>
                        <th class="text-center">
                          Inicio
                        </th>
                        <th class="text-center">Fim</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="day in weekPlan" :key="day.day">
                        <td class="text-center">
                          <v-switch
                            class="mt-0"
                            v-model="day.active"
                            dense
                            :label="day.day"
                            hide-details
                            v-on:change="activeDay(day)"
                          ></v-switch>
                        </td>
                        <td class="text-center">
                          <v-text-field
                            :disabled="!day.active || disableForm"
                            type="time"
                            v-model="day.start"
                            dense
                            hide-details
                            v-on:change="forceReloadTable()"
                          ></v-text-field>
                        </td>
                        <td class="text-center">
                          <v-text-field
                            :disabled="!day.active || disableForm"
                            type="time"
                            v-model="day.end"
                            dense
                            hide-details
                            v-on:change="forceReloadTable()"
                          ></v-text-field>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="secondary"
          v-if="mode == 'create'"
          text
          v-on:click="createPhone()"
          >Inserir Número</v-btn
        >
        <v-btn
          color="secondary"
          v-if="mode == 'edit'"
          text
          v-on:click="updatePhone()"
          >Alterar Número</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import Swal from "sweetalert2";
import { mask } from "vue-the-mask";
export default Vue.extend({
  props: ["phone", "mode", "mobile"],
  directives: { mask },
  data: () => ({
    disableForm: false,
    formValid: true,
    forceReload: 0,
    phoneData: {
      name: "",
      number: "",
      schedule: {
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: []
      }
    },
    rules: {
      required: [
        (v) => !!v || "Nome Obrigatório",
        (v) => (v && v.length <= 15) || "Excedido Limite de tamanho"
      ],
      phone: [
        (v) => !!v || "Número Obrigatório",
        (v) => (v && v.length >= 19) || "O número não está completo"
      ]
    },
    weekPlan: [
      { day: "DOM", active: 1, start: "00:00", end: "23:59" },
      { day: "SEG", active: 1, start: "00:00", end: "23:59" },
      { day: "TER", active: 1, start: "00:00", end: "23:59" },
      { day: "QUA", active: 1, start: "00:00", end: "23:59" },
      { day: "QUI", active: 1, start: "00:00", end: "23:59" },
      { day: "SEX", active: 1, start: "00:00", end: "23:59" },
      { day: "SAB", active: 1, start: "00:00", end: "23:59" }
    ],
    phoneEditor: false
  }),
  computed: {},
  methods: {
    checkIfHourIsValid: function(day) {
      const start = day.start != null && day.start != "";
      const end = day.end != null && day.end != "";
      return start && end;
    },
    activeDay: function(day) {
      if (day.active) {
        this.weekPlan.forEach((Element) => {
          if (Element.day == day.day) {
            Element.start = "00:00";
            Element.end = "23:59";
          }
        });
      }
      this.forceReload = +new Date();
    },
    forceReloadTable: function() {
      this.forceReload = +new Date();
    },
    prepareToCreateNewPhone: function() {
      this.phoneData.name = "";
      this.phoneData.number = "";
    },
    loadPhoneDetails: async function() {
      Axios.get("/api/v1/phones/load", {
        params: {
          id: this.phone
        }
      }).then((response) => {
        const data = response.data;
        if (data.status == "success") {
          this.phoneData = data.data;
          let v = this.phoneData.number;
          v = v.replace(/\D/g, "");
          this.phoneData.number = v.replace(
            /^(\d{2})(\d{2})(\d{4,5})(\d{4})/g,
            "+$1 ($2) $3-$4"
          );
          this.formatweekPlan();
        }
      });
    },
    formatScheduleData: function() {
      const week = this.weekPlan;
      this.phoneData.schedule.sun = week[0].active
        ? [[week[0].start, week[0].end]]
        : [[null, null]];
      this.phoneData.schedule.mon = week[1].active
        ? [[week[1].start, week[1].end]]
        : [[null, null]];
      this.phoneData.schedule.tue = week[2].active
        ? [[week[2].start, week[2].end]]
        : [[null, null]];
      this.phoneData.schedule.wed = week[3].active
        ? [[week[3].start, week[3].end]]
        : [[null, null]];
      this.phoneData.schedule.thu = week[4].active
        ? [[week[4].start, week[4].end]]
        : [[null, null]];
      this.phoneData.schedule.fri = week[5].active
        ? [[week[5].start, week[5].end]]
        : [[null, null]];
      this.phoneData.schedule.sat = week[6].active
        ? [[week[6].start, week[6].end]]
        : [[null, null]];
    },
    formatweekPlan: function() {
      const schedule = this.phoneData.schedule;
      this.weekPlan[0] = {
        day: "DOM",
        start: schedule.sun.length > 0 ? schedule.sun[0][0] : null,
        end: schedule.sun.length > 0 ? schedule.sun[0][1] : null
      };
      this.weekPlan[1] = {
        day: "SEG",
        start: schedule.mon.length > 0 ? schedule.mon[0][0] : null,
        end: schedule.mon.length > 0 ? schedule.mon[0][1] : null
      };
      this.weekPlan[2] = {
        day: "TER",
        start: schedule.tue.length > 0 ? schedule.tue[0][0] : null,
        end: schedule.tue.length > 0 ? schedule.tue[0][1] : null
      };
      this.weekPlan[3] = {
        day: "QUA",
        start: schedule.wed.length > 0 ? schedule.wed[0][0] : null,
        end: schedule.wed.length > 0 ? schedule.wed[0][1] : null
      };
      this.weekPlan[4] = {
        day: "QUI",
        start: schedule.thu.length > 0 ? schedule.thu[0][0] : null,
        end: schedule.thu.length > 0 ? schedule.thu[0][1] : null
      };
      this.weekPlan[5] = {
        day: "SEX",
        start: schedule.fri.length > 0 ? schedule.fri[0][0] : null,
        end: schedule.fri.length > 0 ? schedule.fri[0][1] : null
      };
      this.weekPlan[6] = {
        day: "SAB",
        start: schedule.sat.length > 0 ? schedule.sat[0][0] : null,
        end: schedule.sat.length > 0 ? schedule.sat[0][1] : null
      };
      this.weekPlan.forEach((Element) => {
        Element.active = this.checkIfHourIsValid(Element);
      });
      this.forceReloadTable();
    },
    createPhone: function() {
      this.formatScheduleData();
      let dataReturn;
      if (this.$refs.form.validate()) {
        this.disableForm = true;
        Swal.fire({
          title: "Confirma a insersão deste novo Número?",
          showCancelButton: true,
          confirmButtonColor: "#60ba8e",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#B80C09",
          reverseButtons: true,
          icon: "question",
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: async () => {
            this.phoneData.name = this.titleCase(this.phoneData.name);
            await Axios.post("/api/v1/phones/add", {
              newdata: this.phoneData
            }).then((response) => {
              dataReturn = response.data;
            });
          }
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: dataReturn.status == "success" ? "Concluído!" : "Erro!",
              text: dataReturn.msg,
              icon: dataReturn.status == "success" ? "success" : "error",
              confirmButtonText: "OK!"
            }).then(() => {
              if (dataReturn.status == "success") {
                this.$emit("reload-data");
                this.phoneEditor = false;
              }
            });
          }
          this.disableForm = false;
        });
      }
    },
    updatePhone: function() {
      this.formatScheduleData();
      let dataReturn;
      if (this.$refs.form.validate()) {
        this.disableForm = true;
        Swal.fire({
          title: "Confirma a alteração deste Número?",
          showCancelButton: true,
          confirmButtonColor: "#60ba8e",
          confirmButtonText: "Confirmar",
          cancelButtonText: "Cancelar",
          cancelButtonColor: "#B80C09",
          reverseButtons: true,
          icon: "question",
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !Swal.isLoading(),
          preConfirm: async () => {
            this.phoneData.name = this.titleCase(this.phoneData.name);
            await Axios.put("/api/v1/phones/update", {
              id: this.phone,
              data: this.phoneData
            }).then((response) => {
              dataReturn = response.data;
            });
          }
        }).then((result) => {
          if (result.value) {
            Swal.fire({
              title: dataReturn.status == "success" ? "Concluído!" : "Erro!",
              text: dataReturn.msg,
              icon: dataReturn.status == "success" ? "success" : "error",
              confirmButtonText: "OK!"
            }).then(() => {
              if (dataReturn.status == "success") {
                this.$emit("reload-data");
                this.phoneEditor = false;
              }
            });
          }
          this.disableForm = false;
        });
      }
    },
    titleCase: function(str) {
      const splitStr = str.toLowerCase().split(" ");
      for (let i = 0; i < splitStr.length; i++) {
        splitStr[i] =
          splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      return splitStr.join(" ");
    }
  },
  mounted() {
    //
  }
});
</script>
<style>
.closeBtn {
  float: right;
  cursor: pointer;
  position: relative;
}
</style>
